import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export const managementDatatableMixin = {
  mixins: [checkPermissionsMixin],

  props: {
    paginationFromParent: {
      type: Object,
    },

    searchFromParent: {
      Type: String,
    },
  },

  data() {
    return {
      rowsPerPageText: this.$i18n.t("tables.RowsPerPage"),
      rowsPerPageItems: [15, 50, 100],
      prevIcon: "mdi-menu-left",
      nextIcon: "mdi-menu-right",
      sortIcon: "mdi-menu-down",
      loading: false,

      itemToDelete: {},
      deleteDialog: false,

      permissionName: "",

      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
    };
  },

  computed: {
    userCanEditOrRemoveItems() {
      return (
        this.userHasPermissionTo("update") ||
        this.userHasPermissionTo("destroy")
      );
    },

    headers() {
      let headers = this.mainHeaders;
      if (this.userCanEditOrRemoveItems) {
        headers.push({
          text: "",
          value: "action",
          sortable: false,
          width: "5%",
          align: "left",
        });
      }
      return headers;
    },

    selectable() {
      if (this.actionType) {
        return this.actionType === "create" || this.actionType === "edit";
      } else return false;
    },
  },

  watch: {
    paginationFromParent(newValue) {
      if (newValue !== null) {
        this.updateLocalPagination(newValue);
      }
    },
  },

  methods: {
    userHasPermissionTo(action) {
      return this.userHasManagementPermission(this.permissionName, action);
    },
    userHasFiberPermissionTo(action) {
      return this.userHasFibercloudPermission(this.permissionName, action);
    },

    askConfirmationToDeleteItem(item) {
      if (
        this.userHasPermissionTo("destroy") ||
        this.userHasManagementPermission("custom_list", "destroy")
      ) {
        this.itemToDelete = item;
        this.deleteDialog = true;
      }
    },
    getRowsFromLocalStorage(id) {
      let rows = parseInt(localStorage.getItem(id));
      if (rows) {
        return rows;
      } else {
        return 15;
      }
    },
    setRowsOnLocalStorage(id, rows) {
      localStorage.setItem(id, rows);
    },
    confirmDelete() {
      this.deleteDialog = false;
      this.itemToDelete = {};
    },

    cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = {};
    },

    updatePaginationInParent(pagination) {
      this.$emit("update-pagination", pagination);
    },

    updateLocalPagination(pagination) {
      if (pagination) {
        this.pagination = pagination;
      }
    },

    updateSearchInParent(search) {
      this.$emit("update-search", search);
    },
  },

  beforeDestroy() {
    this.updatePaginationInParent(this.pagination);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/management/managementDatatableMixin.js